export default __webpack_public_path__ + "static/media/ProposalActive.0ce2da22.svg";